import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-auto" }) => (
  <img src="/logo-mark.png" alt="Swarajya Solar Services" className={`${className} object-contain`} />
);

const Logo = ({ imgClass = "h-12 md:h-14 w-auto" }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group shrink-0">
    <img
      src="/logo-full.png"
      alt="Swarajya Solar Services"
      className={`${imgClass} object-contain transition-transform duration-300 group-hover:scale-[1.03]`}
    />
  </Link>
);

export default Logo;
